import React, { useEffect } from 'react';
import cl from './Modal.module.css' 
import Time from "../../../assets/Icon/Time";

const Modal = ({size, children, isOpen, onClose }) => {
 
    useEffect(() => { 
        const handleKeyPress = (event) => {
            if (event.key === 'Escape') {
              onClose();
            }
          };
 
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', handleKeyPress);
        } else {
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', handleKeyPress);
        }
  
        return () => {
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [isOpen, onClose]);

  
    if (!isOpen) {
         return null;
    }

 
    let  modalSize = 'small';

    if (size === "large") {
           modalSize = cl.large ;
    } 

    if (size === "medium") {
           modalSize = cl.medium ;
    } 

    if (size === "xl") {
           modalSize = cl.xl ;
    } 
 
    const modalClassName = `${cl.modalBox} ${modalSize}`;
 
    return (
        <div className={modalClassName}>
             { /* onClick={onClose} */ }
            <div className={ cl.modalBG }   ></div>
                <div className={cl.modalCrm }  >
                    <div className={cl.modalBody }  >
                        {children}
                        <div className={cl.closeBtn } onClick={onClose}>
                             esc
                            <span>
                                <Time/>
                            </span>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default Modal;